import * as Yup from 'yup';

const schema = Yup.object().shape({
  nome: Yup.string().required('Valor requerido'),
  nome_rota: Yup.string().required('Valor requerido'),
});

export default schema;
